export const titleStyle = {
  paddingTop: "10px",
  fontSize: "12px",
  fontWeight: 550,
};
